<template lang="html">
    <div>
        <div class="hero-section">
            <div class="container container-medium">
                <h1 class="text-center heading black">{{ $t('bp_company_advantages') }}</h1>
                <div class="line"></div>
                <h2 class="text-center heading heading-medium">{{ $t('bp_one_account_multiple_advantages') }}</h2>
                <div class="text-center">
                    <router-link :to="{name: 'contact'}">
                        <div class="btn btn-purple">
                            {{ $t('bp_contact_us_for_personalized_solution') }}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="online-emit-section">
            <div class="container container-medium">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 order-1 order-md-0">
                        <h2 class="heading heading-medium">{{ $t('bp_online_emission') }}</h2>
                        <div>{{ $t('bp_online_assistance') }}.</div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-11 col-11 order-0 order-md-1">
                        <img src="../media/img_24h@2x.png" alt="24h available service"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="container container-wide import-park-section">
            <div class="row m-0">
                <div class="col-lg-6 col-md-6 col-sm-12 pl-0">
                    <img src="../media/beneficii@2x.png" alt="24h available service"/>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h2 class="heading heading-medium">{{ $t('bp_import_your_cars') }}</h2>
                    <div class="row">
                        <div class="col-lg-7">{{ $t('bp_import_you_cars_through_excel') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="plus-section container container-medium" v-if="isMobile()">
            <h2 class="text-center extra-bold heading heading-medium">{{ $t('bp_heading') }}</h2>
            <div class="row justify-content-center mt-4 mt-md-5">
                <carousel :per-page="1" :mouse-drag="false">
                    <slide>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon many-profiles-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('bp_multiple_profiles') }}</h3>
                            <p class="reading">{{ $t('bp_multiple_profiles_for_same_email') }}</p>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon rovignette-status-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('bp_vignettes_status') }}</h3>
                            <p class="reading">{{ $t('bp_verify_vignette_status') }}</p>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12 col-12 text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon comands-history-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('bp_orders_history') }}</h3>
                            <p class="reading">{{ $t('bp_orders_history_description') }}</p>
                        </div>
                    </slide>
                    <slide>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon multiple-comands-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('bp_multiple_orders') }}</h3>
                            <p class="reading">{{ $t('bp_multiple_orders_description') }}</p>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon notificare-expirare-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('bp_email_sms_confirmation') }}</h3>
                            <p class="reading">{{ $t('bp_email_sms_confirmation_description') }} <span class="free-label">{{ $t('free') }}</span></p>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-12 col-12 text-center">
                            <div class="d-flex justify-content-center">
                                <div class="icon servicii-profesioniste-icon"></div>
                            </div>
                            <h3 class="heading heading-small">{{ $t('bp_expiry_alerts') }}</h3>
                            <p class="reading">{{ $t('bp_expiry_alerts_description') }}</p>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>

        <div class="plus-section container container-medium" v-if="!isMobile()">
            <h2 class="text-center extra-bold heading heading-medium">{{ $t('bp_heading') }}</h2>
            <div class="row justify-content-center mt-4 mt-md-5">
                <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon many-profiles-icon"></div>
                    </div>
                    <h3 class="heading heading-small">{{ $t('bp_multiple_profiles') }}</h3>
                    <p class="reading">{{ $t('bp_multiple_profiles_for_same_email') }}</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon rovignette-status-icon"></div>
                    </div>
                    <h3 class="heading heading-small">{{ $t('bp_vignettes_status') }}</h3>
                    <p class="reading">{{ $t('bp_verify_vignette_status') }}</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon comands-history-icon"></div>
                    </div>
                    <h3 class="heading heading-small">{{ $t('bp_orders_history') }}</h3>
                    <p class="reading">{{ $t('bp_orders_history_description') }}</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 col-12 text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon multiple-comands-icon"></div>
                    </div>
                    <h3 class="heading heading-small">{{ $t('bp_multiple_orders') }}</h3>
                    <p class="reading">{{ $t('bp_multiple_orders_description') }}</p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 col-12 text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon notificare-expirare-icon"></div>
                    </div>
                    <h3 class="heading heading-small">{{ $t('bp_email_sms_confirmation') }}</h3>
                    <p class="reading">{{ $t('bp_email_sms_confirmation_description') }} <span class="free-label">{{ $t('free') }}</span></p>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 col-12 text-center">
                    <div class="d-flex justify-content-center">
                        <div class="icon servicii-profesioniste-icon"></div>
                    </div>
                    <h3 class="heading heading-small">{{ $t('bp_expiry_alerts') }}</h3>
                    <p class="reading">{{ $t('bp_expiry_alerts_description') }}</p>
                </div>
            </div>
        </div>

        <div class="need-help-section container container-small">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <h2 class="text-center heading heading-medium">{{ $t('bp_need_help') }}</h2>
                    <div class="d-flex justify-content-center my-3">
                        <div class="icon need-help-icon"></div>
                    </div>
                    <p class="reading text-center">{{ $t('bp_call_operators') }}</p>
                </div>
            </div>
            <div class="text-center">
                <router-link :to="{ name: 'distribution' }" class="main-link">{{ $t('bp_offices') }}</router-link>
            </div>
        </div>

        <div class="flota-section container container-small mt-5">
            <div>
                <h2 class="text-center heading heading-medium">{{ $t('bp_have_cars') }}</h2>
                <div class="d-flex justify-content-center my-3">
                    <div class="icon flota-auto-icon"></div>
                </div>
                <p class="text-center mb-4 reading">{{ $t('bp_contact_us_for_personalized_solution_for_your_bussiness') }}</p>
            </div>
            <div class='text-center'>
                <router-link :to="{name: 'contact'}">
                    <div class="main-btn" href="/">
                        {{ $t('bp_contact_us_now') }}
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from './Header.vue'
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        name: 'Homepage',
        components: {
            Header,
            Carousel,
            Slide
        },
        props: {
        },
        computed: {
        },
        data: function() {
            return {
            }
        },
        mounted() {

        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    h2{
        font-weight: bold;
    }
    .main-link{
        font-weight: bold;
    }
    .hero-section{
        background-color: #EDE9F2;
        padding: 160px 0;

        h1 {
            font-weight: 900;
            padding-bottom: 50px;

            @media only screen and (max-width: 768px) {
                padding-bottom: 26px;
            }
        }

        h2 {
            font-weight: bold;
            padding-bottom: 58px;

            @media only screen and (max-width: 768px) {
                padding-bottom: 39px;
            }
        }

        .line {
            height: 6px;
            width: 100px;
            background-color: #0F2443;
            margin: 0 auto;
            display: block;
            margin-bottom: 50px;

            @media only screen and (max-width: 768px) {
                margin-bottom: 24px;
            }
        }

        .btn-purple {
            font-size: 18px;
            padding: 20px;
        }
    }
    .online-emit-section{
        background-color: #FAF9F6;
        padding: 120px 0;
        font-size: 20px;
        font-weight: 300;
        h2 {
            font-weight: bold;
            padding: 60px 0 10px;
        }

        p {
            font-weight: 500;

        }
    }
    .container-wide{
        max-width: 100%;
        width: 100%;
        &.import-park-section{
            background-color: #FAF9F6;
            padding: 120px 0;
            font-size: 20px;
            font-weight: 300;

            h2 {

                padding: 150px 0 0px 0;
            }

            p {
                font-weight: 500;

            }
            .benefits{
                padding-top: 103px;
                h1{

                    font-weight: bold;
                }
                .pasi-wrapper{
                    .add-cart-wrapper, .card-payment-wrapper, .semafor-wrapper{
                        flex: 1;
                        padding: 60px 17px 0 17px;
                        h3{

                            font-weight: bold;
                            margin: 20px 0 0 0;
                        }
                        p{

                            a{
                                text-decoration: underline;

                                &:hover{
                                    color: #737880;
                                }
                            }
                        }
                    }
                    .card-payment-wrapper{
                        p{
                            margin: 19px 0 0 0;
                        }
                    }
                    .add-cart-wrapper{
                        p{
                            margin: 15px 0 0 0;
                        }
                    }
                    .semafor-wrapper{
                        p{
                            margin: 19px 0 0 0;
                        }
                    }
                }
            }
        }
    }
    .plus-section{
        h2 {
            padding-top: 0px;
        }

        h3 {
            margin-top: 10px;
            font-weight: bold;

        }
    }
    .need-help-section{
        padding-top: 140px;
    }
    .plus-section{
        padding-top: 40px;

        @media only screen and (max-width: 767px) {
            padding-top: 88px;
        }
    }
    .flota-section{
        padding-top: 100px;
        padding-bottom: 100px;

        .main-btn {
            @media only screen and (min-width: 768px) {
                max-width: 327px;
            }
        }
    }
    .free-label{
        border-radius: 3px;
        border: 1px solid #2ED06E;
        color: #2ED06E;
        background-color: #e8f7e1;
        padding: 2px 4px;
        font-size: 13px;
    }

    @media only screen and (max-width: 768px) {
        .hero-section{
            padding: 60px 0;
        }

        .online-emit-section{
            padding: 91px 0;

            h2 {
                padding: 30px 0 0 0;
            }
        }

        .container-wide{

            &.import-park-section{
                padding: 0;

                h2{
                    padding: 30px 0 0;
                }
            }
        }
        .need-help-section {
            padding-top: 60px;
        }

        .flota-section {
            padding-top: 40px;
        }
    }

</style>
